/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import connector from '../connector';

const addFarmsList = (farmsList) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('farms', 'readwrite');
        const farmsStore = transaction.objectStore('farms');

        farmsStore.clear(); // delete all of the previously added farms to add the new list

        farmsList.forEach(singleFarm => {
            farmsStore.add(singleFarm);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getFarmsList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('farms', 'readonly');
        const farmsStore = transaction.objectStore('farms');

        const allFarms = farmsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allFarms.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getFarmByName = (name) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('farms', 'readonly');
        const farmsStore = transaction.objectStore('farms');
        const nameIndex = farmsStore.index('NameIndex');

        const farmResult = nameIndex.get(name);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: farmResult.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const farms = {
    addFarmsList,
    getFarmsList,
    getFarmByName
}

export default farms;
